export default __webpack_public_path__ + "static/media/8.d4db5bb7.png";